import { Component, For } from 'solid-js';

export interface SessionItem {
  id: string;
  name: string;
  updatedAt: number;
}

interface SessionsBarProps {
  sessions: SessionItem[];
  currentId: string;
  onSelect: (id: string) => void;
  onNew: () => void;
  onRename: (id: string, name: string) => void;
  onDelete: (id: string) => void;
  onDuplicate: (id: string) => void;
  onExport?: (id: string) => void;
}

export const SessionsBar: Component<SessionsBarProps> = (props) => {
  return (
    <nav class="sessions-bar" aria-label="Chat sessions">
      <div class="sessions-list" aria-label="Conversations">
        <For each={props.sessions}>
          {(s) => (
            <div
              class={`session-tab ${props.currentId === s.id ? 'active' : ''}`}
              data-selected={props.currentId === s.id}
              title={new Date(s.updatedAt).toLocaleString()}
            >
              <button
                type="button"
                class="session-select mini-btn"
                aria-label={`Select ${s.name}`}
                onClick={() => props.onSelect(s.id)}
              >
                <span class="session-name">{s.name}</span>
              </button>
              <div class="session-actions" role="group" aria-label="Session actions">
                <button
                  type="button"
                  class="mini-btn"
                  title="Rename"
                  aria-label="Rename session"
                  onClick={(e) => {
                    e.stopPropagation();
                    const next = prompt('Rename conversation', s.name);
                    if (typeof next === 'string' && next.trim()) props.onRename(s.id, next.trim());
                  }}
                >✏️</button>
                <button
                  type="button"
                  class="mini-btn"
                  title="Duplicate"
                  aria-label="Duplicate session"
                  onClick={(e) => { e.stopPropagation(); props.onDuplicate(s.id); }}
                >📄</button>
                <button
                  type="button"
                  class="mini-btn"
                  title="Export JSON"
                  aria-label="Export session"
                  onClick={(e) => { e.stopPropagation(); props.onExport?.(s.id); }}
                >💾</button>
                <button
                  type="button"
                  class="mini-btn"
                  title="Delete"
                  aria-label="Delete session"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (confirm('Delete this conversation?')) props.onDelete(s.id);
                  }}
                >🗑️</button>
              </div>
            </div>
          )}
        </For>
        <button type="button" class="session-new" onClick={props.onNew} aria-label="New conversation">＋ New</button>
      </div>
    </nav>
  );
};
